<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Revert Adjustments</h1>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-correction-line-filter providerJsonPath="providerId" (search)="onSearch($event)" (clear)="onClear()"></ppl-correction-line-filter>
                    <p><strong>Note:</strong></p>
                    <ul>
                        <li>Lists adjusted and voided lines whose adjustment can be reverted.</li>
                        <li>Select the lines and use <strong>Revert</strong> to restore them to their state before the
                            adjustment.</li>
                    </ul>
                </div>
                <div class="table-style">
                    @if (hasSearched) {
                    <ppl-list-table [cols]="cols" [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [data]="lines" [customDataLoaded]="true" [enableActions]="false"
                        [gridTitle]="false" [pagination]="true" [loadPage]="true" (onPageLoad)="onPageLoad($event)"
                        [actionButtons]="actionButtons" [enablePageActions]="!isReadOnly"
                        [listButton]="isReadOnly ? [] : buttons" (actionInvoked)="gridAction($event)">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning">Search by Provider PPL ID or Participant PPL ID to see lines.</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ppl-correction-notes-dialog [(visible)]="showRevertPopup" title="Revert Adjustment" okText="Revert"
    [message]="selectedLines.length + ' selected line(s) will be reverted.'"
    placeholder="Reason for reverting the adjustment" (confirmed)="submitRevert($event)">
</ppl-correction-notes-dialog>
